import { can, me } from "../services/access.js";

const NAV = [
  { id: "settings", t: "Settings", ok: () => true, foot: true },
  { grp: "Workspace" },
  { id: "overview", t: "Overview", ok: () => true },
  { id: "me", t: "My records", ok: () => can("ess") && !!me().emp },
  { grp: "Accounting" },
  { id: "projects", t: "Projects", ok: () => can("proj.view") },
  {
    id: "sites",
    t: "Sites & locations",
    ok: () => can("proj.view") || can("pay.view") || can("fs.view"),
  },
  {
    id: "accounting",
    t: "Accounting",
    ok: () => can("gl.view") || can("fs.view") || can("bir.view"),
  },
  { grp: "HR Payroll" },
  {
    id: "worklogs",
    t: "Work logs",
    ok: () => can("dep.view") || can("dep.log"),
  },
  { id: "people", t: "Employees", ok: () => can("hr.view") },
  { id: "deploy", t: "Deployments", ok: () => can("dep.view") },
  {
    id: "leave",
    t: "Leave approvals",
    ok: () => can("leave.all") || can("leave.team"),
  },
  { id: "payroll", t: "Payroll", ok: () => can("pay.view") },
  { grp: "Reporting" },
  {
    id: "statutory",
    t: "Statutory & Benefits",
    ok: () => can("hr.salary") || can("pay.approve"),
  },
  {
    id: "reports",
    t: "Reports",
    ok: () =>
      can("fs.view") ||
      (can("pay.view") && (can("hr.salary") || can("pay.approve"))),
  },
  {
    id: "analytics",
    t: "Analytics",
    ok: () =>
      can("fs.view") ||
      (can("pay.view") && (can("hr.salary") || can("pay.approve"))),
  },
];

export { NAV };
